import styled from 'styled-components';
import svgChecked from '../../assets/svg/icon-check-white.svg';

export const CreateTagFormSC = styled.div`
  .ui-select,
  .ui-textfield {
    width: 100%;
  }

  .circle-picker {
    width: 100% !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    border-radius: 12px !important;
    border: 2px solid ${({ theme }) => theme.color.border.regular};
    background: ${({ theme }) => theme.color.surface.variant};
    padding: 10px;
    padding-right: 0;
    padding-bottom: 0;
    align-items: center;
    justify-content: space-between;

    transition: all 0.2s;
  }

  .ui-form-field {
    &.ui-form-field-error {
      .circle-picker {
        border: 2px solid ${({ theme }) => theme.color.border.error} !important;
        background: ${({ theme }) => theme.color.surface.error};
      }
    }

    &:hover {
      .circle-picker {
        border: 2px solid
          ${({ theme }) => theme.createOverlayColor(theme.color.border.regular, 'hover')} !important;
        background: ${({ theme }) =>
          theme.createOverlayColor(theme.color.surface.variant, 'hover')};
      }

      &.ui-form-field-error {
        .circle-picker {
          border: 2px solid
            ${({ theme }) => theme.createOverlayColor(theme.color.border.error, 'hover')} !important;
          background: ${({ theme }) =>
            theme.createOverlayColor(theme.color.surface.error, 'hover')};
        }
      }
    }
  }

  .submit-button {
    margin-top: 15px;
  }

  .time-select-fields {
    display: flex;
    justify-content: space-between;
  }

  .submit-area {
    display: flex;
    justify-content: space-between;
  }

  .required {
    color: rgba(255, 51, 92, 1);
  }
`;

export const TwitterPickerSC = styled.div<{ color: string | undefined }>`
  .twitter-picker {
    div {
      .active {
        box-shadow: 0px 0px 4px ${({ color }) => color} !important;
        &:before {
          content: '';
          width: 15px;
          height: 15px;
          background: url(${svgChecked}) no-repeat center;
          position: absolute;
          transform: translate(-50%, -50%);
          left: 50%;
          top: 50%;
        }
      }
    }
  }
`;
